import React from 'react';

const Navbar = () => {
  return (
    <nav className='navbar navbar-expand-lg navbar-dark bg-primary'>
      <span className='navbar-brand mb-0 h1 mx-auto'>
        <legend>LyricFinder</legend>
      </span>
    </nav>
  );
};

export default Navbar;
